import type { PropsWithChildren } from 'react';
import React from 'react';

import { Layout } from './Layout';
import type { DefaultLayoutProps } from './shared/types';

export const DefaultLayout = ({
	children,
	...props
}: PropsWithChildren<DefaultLayoutProps> & { suppressHydrationWarning?: boolean }): React.JSX.Element | null => {
	return <Layout {...props}>{children}</Layout>;
};
